import React, { useState } from 'react';
import SelectEventPage from '../../containers/SelectEventPage/SelectEventPage';
import CreateEventPage from '../../containers/CreateEventPage/CreateEventPage';

const modes = {
  SELECT: 'select',
  CREATE: 'create',
};

export default () => {
  const [mode, setMode] = useState(modes.SELECT);
  if (mode === modes.SELECT) {
    return <SelectEventPage switchToCreateMode={() => setMode(modes.CREATE)} />;
  }
  if (mode === modes.CREATE) {
    return <CreateEventPage switchToSelectMode={() => setMode(modes.SELECT)} />;
  }
  return null;
};
